import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { CategoriesLoadingDialog } from "./categories-loading-dialog/CategoriesLoadingDialog";
import { CategoryDeleteDialog } from "./category-delete-dialog/CategoryDeleteDialog";
import { CategoriesDeleteDialog } from "./categories-delete-dialog/CategoriesDeleteDialog";
import { CategoriesFetchDialog } from "./categories-fetch-dialog/CategoriesFetchDialog";
import { CategoriesUpdateStatusDialog } from "./categories-update-status-dialog/CategoriesUpdateStatusDialog";
import { CategoriesCard } from "./CategoriesCard";
import { CategoriesUIProvider } from "./CategoriesUIContext";

const sub_path = "/category/pending";

function CategoriesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesDeleteDialog show={location.pathname === "/category/pending/deleteCategories"} onHide={() => navigate("/category/pending")} />;
}
function CategoryDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <CategoryDeleteDialog show id={id} onHide={() => navigate("/category/pending")} />;
}
function CategoriesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesFetchDialog show={location.pathname === "/category/pending/fetch"} onHide={() => navigate("/category/pending")} />;
}
function CategoriesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesUpdateStatusDialog show={location.pathname === "/category/pending/updateStatus"} onHide={() => navigate("/category/pending")} />;
}

export function CategoriesPagePending() {
  const navigate = useNavigate();
  const categoriesUIEvents = {
    newCategoryButtonClick: () => navigate("/category/new"),
    openEditCategoryPage: (id) => navigate(`/category/${id}/edit`),
    openDeleteCategoryDialog: (id) => navigate(sub_path + "/delete/" + id),
    openDeleteCategoriesDialog: () => navigate(sub_path + "/deleteCategories"),
    openFetchCategoriesDialog: () => navigate(sub_path + "/fetch"),
    openUpdateCategoriesStatusDialog: () => navigate(sub_path + "/updateStatus"),
  };

  return (
    <CategoriesUIProvider categoriesUIEvents={categoriesUIEvents}>
      <CategoriesLoadingDialog />
      <Routes>
        <Route path="deleteCategories" element={<CategoriesDeleteDialogRoute />} />
        <Route path="delete/:id" element={<CategoryDeleteDialogRoute />} />
        <Route path="fetch" element={<CategoriesFetchDialogRoute />} />
        <Route path="updateStatus" element={<CategoriesUpdateStatusDialogRoute />} />
      </Routes>
      <CategoriesCard />
    </CategoriesUIProvider>
  );
}
